module.exports = __webpack_public_path__ + "img/chevron-prev.4183fe77.svg";